import { Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { TranslationRequest } from '../../models/translation/translation-request';
import { SentenceCasePipe } from '../../pipes/sentence-case.pipe';

@Component({
    selector: 'app-value',
    template: `
    @if (shouldShow) {
      @if (layout === 'row') {
        <div class="tw-flex tw-items-center tw-py-0.5">
          <div class="label row-label">
            @if (label) {
              {{
              translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
              }}
            } @else {
              <ng-content select="[label]"></ng-content>
            }
          </div>
          <div class="row-value">
            <div>
              @if (value) {
                {{
                translationNeeded ? (value | translation: translationRequest) : value
                }}
              } @else if (valueTemplate) {
                <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
              } @else {
                <ng-content select="[value]"></ng-content>
              }
            </div>
          </div>
        </div>
      }
      @if (layout === 'row-flex-start') {
        <div class="tw-flex tw-items-start tw-py-0.5">
          <div class="label row-label row-nowrap">
            @if (label) {
              {{
              translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
              }}
            } @else {
              <ng-content select="[label]"></ng-content>
            }
          </div>
          <div class="row-value">
            <div>
              @if (value) {
                {{
                translationNeeded ? (value | translation: translationRequest) : value
                }}
              } @else if (valueTemplate) {
                <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
              } @else {
                <ng-content select="[value]"></ng-content>
              }
            </div>
          </div>
        </div>
      }
      @if (layout === 'row-baseline') {
        <div class="tw-flex  tw-py-0.5">
          <div class="label row-label">
            @if (label) {
              {{
              translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
              }}
            } @else {
              <ng-content select="[label]"></ng-content>
            }
          </div>
          <div class="row-value">
            <div>
              @if (value) {
                {{
                translationNeeded ? (value | translation: translationRequest) : value
                }}
              } @else {
                <ng-content select="[value]"></ng-content>
              }
            </div>
          </div>
        </div>
      }
      
      @if (layout === 'row-xs') {
        <div class="tw-flex tw-items-center tw-py-0.5">
          @if (label) {
            <div
              class="label row-xs-label app-pr1 tw-inline-block md:tw-hidden"
              [ngClass]="labelStyle ?? ''"
              >
              @if (label) {
                {{
                translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
                }}
              } @else {
                <ng-content select="[label]"></ng-content>
              }
            </div>
          }
          <div class="row-value">
            @if (value) {
              {{
              translationNeeded ? (value | translation: translationRequest) : value
              }}
            } @else if (valueTemplate) {
              <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
            } @else {
              <ng-content select="[value]"></ng-content>
            }
          </div>
        </div>
      }
      
      @if ((layout === 'col' || layout === 'default') && addColon) {
        <div [ngClass]='value || valueTemplate ? "col-container" : ""'>
          <div class='col-label label'>
            @if (label) {{{
              translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
            }}} @else {
              <ng-content select="[label]"></ng-content>
            }
          </div>
          <div>
            @if (value) {
              {{
              translationNeeded ? (value | translation: translationRequest) : value
              }}
            } @else if (valueTemplate) {
              <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
            } @else {
              <ng-content select="[value]"></ng-content>
            }
          </div>
        </div>
      }
      
      @if ((layout === 'col' || layout === 'default') && !addColon) {
        <div>
          <div class='label'>
            @if (label) {{{
              translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
            }}} @else {
              <ng-content select="[label]"></ng-content>
            }
          </div>
          <div>
            @if (value) {
              {{
              translationNeeded ? (value | translation: translationRequest) : value
              }}
            } @else if (valueTemplate) {
              <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
            } @else {
              <ng-content select="[value]"></ng-content>
            }
          </div>
        </div>
      }
      
      @if (layout === 'vertical' && label && (value || valueTemplate)) {
        <div
          class="tw-flex label-vertical-top labelTemplateClass"
          >
          <div class="row-value tw-w-[50%] labelTemplateClass">
            @if (label && (value || valueTemplate)) {
              {{  translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel }}
            } @else {
              <ng-content select="[label]"></ng-content>
            }
          </div>
          @if (value) {
            <div class="row-value tw-w-[50%]">
              @if (value) {
                {{
                translationNeeded ? (value | translation: translationRequest) : value
                }}
            } @else {
                <ng-content select="[value]"></ng-content>
              }
            </div>
          }
          @if (valueTemplate) {
            <div class="row-value md:tw-w-[50%]">
              <div>
                <ng-container [ngTemplateOutlet]="valueTemplate"
                  >{{ translationNeeded ? (value | translation: translationRequest) : value }}
                </ng-container>
              </div>
            </div>
          }
        </div>
      }
      
      @if (layout === 'col-xs') {
        <div>
          <div class="label tw-block md:tw-hidden" tabindex="0">
            @if (label) {
              {{
              translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
              }}
            } @else {
              <ng-content select="[label]"></ng-content>
            }
          </div>
          <div>
            @if (value) {
              {{
              translationNeeded ? (value | translation: translationRequest) : value
              }}
            } @else if (valueTemplate) {
              <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
            } @else {
              <ng-content select="[value]"></ng-content>
            }
          </div>
        </div>
      }
      
      @if (layout === 'col-row-xs') {
        <div>
          <div class="tw-inline-block md:tw-hidden">
            <div class="label row-label">
              @if (label) {
                {{
                translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
                }}
              } @else {
                <ng-content select="[label]"></ng-content>
              }
            </div>
            <div class="row-value">
              @if (value) {
                {{
                translationNeeded ? (value | translation: translationRequest) : value
                }}
              } @else if (valueTemplate) {
                <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
              } @else {
                <ng-content select="[value]"></ng-content>
              }
            </div>
          </div>
          <div class="tw-hidden md:tw-block">
            <div class="label">
              @if (label) {
                {{
                translationLabelNeeded ? ( displayLabel | translation: translationRequest) : displayLabel
                }}
              } @else {
                <ng-content select="[label]"></ng-content>
              }
            </div>
            <div>
              @if (value) {
                {{
                translationNeeded ? (value | translation: translationRequest) : value
                }}
              } @else if (valueTemplate) {
                <ng-container [ngTemplateOutlet]="valueTemplate"></ng-container>
              } @else {
                <ng-content select="[value]"></ng-content>
              }
            </div>
          </div>
        </div>
      }
    }
    
    `,
    styles: [
        `
      .labelTemplateClass {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 11px;
        font-weight: bold;
        text-transform: uppercase;
        line-height: 16px;
      }

      :host(.sentence-case) .label {
        text-transform: none;
      }

      .col-container {
        padding-bottom: 14px;
      }

      .col-label:after {
        content: ':';
      }

      .row-label {
        display: inline-block;
        padding-right: 4px;
        white-space: nowrap;
      }

      .row-label:after {
        content: ':';
      }

      .row-xs-label:after {
        content: ':';
      }

      .row-value {
        display: inline-block;
        padding-right: 4px;
        line-height: 16px;
        color: var(--color-slate-600);
      }
      :host {
        display: inline-block;
      }
      :host:focus {
        outline-style: solid;
        outline-width: 2px;
        outline-color: var(--sed-dynamic-black-color) !important;
        outline-offset: 2px;
      }
    `,
    ],
    standalone: false
})
export class ValueComponent {
  /** When true, the row is not rendered if `value` is null, undefined, or whitespace-only. Ignored when `valueTemplate` is set. */
  @Input()
  hideWhenEmpty = false;

  @Input()
  label: string;

  @Input()
  addColon: boolean = false;

  @Input()
  value: any;

  @Input()
  layout: ValueLayout = 'default';

  @Input()
  labelStyle: string;

  @Input()
  valueTemplate: TemplateRef<any>;

  @Input()
  translationNeeded: boolean = true;
  @Input()
  translationLabelNeeded: boolean = true;

  /**
   * When true, the label is rendered in sentence case via the shared SentenceCasePipe
   * and the default uppercase styling on the label is removed.
   */
  @Input()
  labelSentenceCase: boolean = false;

  /**
   * Opt-in companion to `labelSentenceCase`. When true, any all-uppercase token in
   * the supplied label (e.g. "ID", "URL") is kept as-is instead of being lowercased
   * by the sentence-case transform. Has no effect when `labelSentenceCase` is false.
   */
  @Input()
  preserveAcronyms: boolean = false;

  constructor(private sentenceCasePipe: SentenceCasePipe) {}

  get displayLabel(): string {
    if (!this.labelSentenceCase || typeof this.label !== 'string' || !this.label) {
      return this.label;
    }

    const sentenceCased = this.sentenceCasePipe.transform(this.label);
    if (!this.preserveAcronyms) {
      return sentenceCased;
    }

    const sentenceCasedTokens = sentenceCased.split(' ');
    const originalTokens = this.label.split(' ');
    return sentenceCasedTokens
      .map((token, i) => (this.isAcronym(originalTokens[i]) ? originalTokens[i] : token))
      .join(' ');
  }

  private isAcronym(token: string): boolean {
    return !!token && token.length >= 2 && /^[A-Z]+$/.test(token);
  }

  @HostBinding('class.sentence-case')
  get sentenceCaseHostClass(): boolean {
    return this.labelSentenceCase;
  }

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  get shouldShow(): boolean {
    if (!this.hideWhenEmpty) {
      return true;
    }
    if (this.valueTemplate) {
      return true;
    }
    return !this.isEmptyBoundValue(this.value);
  }

  @HostBinding('style.display')
  get hostDisplay(): string | null {
    return this.shouldShow ? null : 'none';
  }

  private isEmptyBoundValue(value: any): boolean {
    if (value === null || value === undefined) {
      return true;
    }
    if (typeof value === 'string') {
      return value.trim() === '';
    }
    return false;
  }

}

type ValueLayout =
  | 'default'
  | 'col'
  | 'row'
  | 'col-xs'
  | 'row-xs'
  | 'col-row-xs'
  | 'col-row-xs-with-icon'
  | 'vertical'
  | 'row-baseline'
  | 'row-flex-start';
